import { render, staticRenderFns } from "./ExamResponse.vue?vue&type=template&id=0a5727dc"
import script from "./ExamResponse.vue?vue&type=script&lang=js"
export * from "./ExamResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports